/**
 * Agrupa áreas Guardian por projeto (project_detail).
 * Doc: docs/LISTAR_AREAS_POR_PROJETO.md
 */
export function groupAreasByProject(areas = []) {
  const list = Array.isArray(areas) ? areas : [];
  const map = new Map();

  for (const area of list) {
    const projectId = area?.project_detail?.id ?? "none";
    const title =
      (area?.project_detail?.title && String(area.project_detail.title).trim()) ||
      (projectId === "none" ? "Sem projeto" : `Projeto #${projectId}`);

    if (!map.has(projectId)) {
      map.set(projectId, {
        projectId,
        projectTitle: title,
        areas: [],
      });
    }
    map.get(projectId).areas.push(area);
  }

  return [...map.values()]
    .sort((a, b) =>
      a.projectTitle.localeCompare(b.projectTitle, "pt-BR", {
        sensitivity: "base",
      })
    )
    .map((group) => ({
      ...group,
      areas: [...group.areas].sort((x, y) =>
        String(x?.name || "").localeCompare(String(y?.name || ""), "pt-BR", {
          sensitivity: "base",
        })
      ),
    }));
}
